'use client';

import { createContext, PropsWithChildren } from 'react';

/**
 * Whether screen locks (see useScreenLock) beneath this provider should hide the page's scrollbar gutter.
 * `false` (the default when no provider is present) keeps the gutter, matching legacy behavior. A page or
 * app sets this once at its root and every screen lock in the subtree adopts it, so individual modals don't
 * need to pass the value down.
 */
export const ScreenLockContext = createContext(false);

type Props = {
  hidePageScrollbarGutter: boolean;
};

export default function ScreenLockProvider({ hidePageScrollbarGutter, children }: PropsWithChildren<Props>) {
  return <ScreenLockContext.Provider value={hidePageScrollbarGutter}>{children}</ScreenLockContext.Provider>;
}
